import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'camelcase',
  standalone: false,
})
export class CamelcasePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  }
}
